import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`
  color: ${colors.white};
  font-size: 18px;
  font-weight: 600;
`;

